//@flow
import reducer from "./reducers";

import * as sectionsOperations from "./operations";
import * as sectionsSelectors from "./selectors";

export { sectionsOperations, sectionsSelectors };

export default reducer;
